import { contactInfo } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-mail-line"></i>
            <span>保持联系</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">联系我们</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            {contactInfo.desc}
          </p>
        </div>

        <div className="max-w-[600px] mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/60 text-primary-500 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
                  <div className="text-sm text-foreground-800 font-medium">{contactInfo.email}</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/60 text-accent-500 flex-shrink-0">
                  <i className="ri-qq-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">QQ 交流群</div>
                  <div className="text-sm text-foreground-800 font-medium">{contactInfo.qq}</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100/60 text-secondary-500 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">微信公众号</div>
                  <div className="text-sm text-foreground-800 font-medium">{contactInfo.wechat}</div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 flex-shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-400 mb-0.5">工作时间</div>
                  <div className="text-sm text-foreground-800 font-medium">{contactInfo.workTime}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}